import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const DashboardContext = React.createContext(null);
export const DashboardProvider = ({ children, dashboardItems, AuthContext, storageProvider, withRouter, loginFallback }) => {
    const dashboardContext = {
        dashboardItems,
        AuthContext,
        storageProvider,
        withRouter,
        loginFallback,
    };
    return _jsx(DashboardContext.Provider, Object.assign({ value: dashboardContext }, { children: children }));
};
//# sourceMappingURL=index.js.map